import { GraphQLFormattedError } from "graphql";

type NotificationApi = {
  addError(message: string, title?: string): void;
};

/**
 * Checks a mutation or query result for GraphQL errors and missing data.
 * The error message is read from the GraphQL error objects; falls back to `fallbackMessage`.
 * Returns `true` only when operation data is available.
 */
type OperationResult<TData> = {
  data?: TData | null;
  errors?: ReadonlyArray<GraphQLFormattedError>;
};

type OperationSuccessResult<TData> = {
  data: NonNullable<TData>;
  errors?: ReadonlyArray<GraphQLFormattedError>;
};

export function validateGraphQLResult<TData>(
  result: OperationResult<TData>,
  notification: NotificationApi,
  fallbackMessage = "Something went wrong.",
): result is OperationSuccessResult<TData> {
  if (result.errors && result.errors.length > 0) {
    const message =
      result.errors.map((e) => e.message).join(" ") || fallbackMessage;
    notification.addError(message);
    return false;
  }

  if (result.data === undefined || result.data === null) {
    notification.addError(fallbackMessage);
    return false;
  }

  return true;
}
